import { transformShippingBusinessHoursDto } from 'data/transformers/shipping-point';
export const transformDropOffPointCarrierDto = _ref => {
  let {
    name,
    icon_url,
    location_map_note
  } = _ref;
  return {
    name,
    iconUrl: icon_url,
    locationMapNote: location_map_note
  };
};
export const transformDropOffPointOpeningStatusDto = _ref2 => {
  let {
    status,
    text
  } = _ref2;
  return {
    status,
    text
  };
};
export const transformDropOffPointDto = _ref3 => {
  let {
    code,
    name,
    distance,
    distance_unit,
    description,
    drop_off_point_address,
    latitude,
    longitude,
    photo_url,
    point_type_icon_url,
    description_icon_url,
    opening_status,
    business_hours
  } = _ref3;
  return {
    code,
    name,
    distance,
    distanceUnit: distance_unit,
    description,
    dropOffPointAddress: drop_off_point_address,
    latitude,
    longitude,
    photoUrl: photo_url,
    pointTypeIconUrl: point_type_icon_url,
    descriptionIconUrl: description_icon_url,
    openingStatus: transformDropOffPointOpeningStatusDto(opening_status),
    businessHours: business_hours === null || business_hours === void 0 ? void 0 : business_hours.map(transformShippingBusinessHoursDto)
  };
};
export const transformNearbyDropOffPointDto = _ref4 => {
  let {
    suggested_drop_off_point_code,
    carrier,
    drop_off_points
  } = _ref4;
  return {
    suggestedDropOffPointCode: suggested_drop_off_point_code,
    carrier: transformDropOffPointCarrierDto(carrier),
    dropOffPoints: drop_off_points.map(transformDropOffPointDto)
  };
};